<template>
  <div class="has-background-white">
    <section class="height-108vh max-height-50rem is-flex">
      <div
        class="container columns margin-right-auto margin-left-auto mb-10 is-relative"
        :class="
          screen === 'mobile' ? 'pa-4' : 'padding-right-70px padding-left-70px'
        "
      >
        <img src="/images/rojgari_teams.png" class="team" />
        <div
          class="swastic column is-5 rounded-10 is-relative mb-0 pa-0 z-index-1 margin-top-auto"
        >
          <div
            class="box pa-4 is-flex is-flex-direction-column has-background-white rounded-10"
          >
            <div class="has-text-grey-light mb-2">About</div>
            <div class="is-size-3 has-text-weight-medium mb-2">Rojgari.com</div>
            <p class="text-14 has-text-justified has-text-centered-mobile">
              Rojgari Services Private Limited, registered under Company Act in
              2012, is a national employment agency working to empower job
              seekers with a wide range of employment related information and
              service, particularly jobs counselling, soft skills training, and
              employment match-making.
              <br />
              Rojgari enlists and connects job seekers and employers in Nepal
              through an online portal www.rojgari.com and Rojgari mobile App.
            </p>
            <a
              id="btn-sign-up"
              class="button is-jobseeker text-14 column is-5 is-flex mt-4"
              @click="goToSignup()"
              v-text="$t('Register')"
            ></a>
          </div>
        </div>
        <div class="column is-1 margin-top-auto pa-0">
          <div class="vertical-line"></div>
        </div>
        <div class="column is-6 pa-0 margin-top-auto z-index-1">
          <div class="has-text-centered pa-2">{{ $t('Trusted By') }}</div>
          <div class="service-image d-grid gap-1 d-placeitem">
            <img
              src="@/static/images/account/ambasdor_logo.jpg"
              alt="kitchen"
              class="lift-shadow pa-4"
            />
            <img
              src="@/static/images/account/hydrebadi_dum.jpg"
              alt="hulas"
              class="lift-shadow pa-4"
            />
            <img
              src="@/static/images/account/bajeko_sekuwa.jpg"
              alt="bajeko"
              class="lift-shadow pa-4"
            />
            <img
              src="@/static/images/account/golden_gate.jpg"
              alt="websurfer"
              class="lift-shadow pa-4"
            />
            <img
              src="@/static/images/account/goyal_logo.jpg"
              alt="lotus"
              class="lift-shadow pa-4"
            />
            <img
              src="@/static/images/account/filli_cafe.jpg"
              alt="healthcare"
              class="lift-shadow pa-4"
            />
            <img
              src="@/static/images/account/grand_norling.jpg"
              alt="zuleika"
              class="lift-shadow pa-4"
            />
            <img
              src="@/static/images/account/haadi_logo.jpg"
              alt="hotel"
              class="lift-shadow pa-4"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="is-flex has-background-light-orange py-10 is-full-width">
      <div
        class="columns container has-margin-auto mb-5 is-full-width"
        :class="
          screen === 'mobile' ? 'pa-4' : 'padding-right-70px padding-left-70px'
        "
      >
        <div class="column is-6">
          <div class="is-size-3 has-text-weight-medium pb-3">
            Job Posting Services
          </div>
          <p class="text-14 has-text-justified has-text-centered-mobile">
            Job posting is an official advertisement to inform job seekers about
            available employment opportunities. Employers use job posting
            services to identify and connect with suitable candidates,
            introducing them to the job and workplace. Once posted, employers
            can review applicant details for a specified time. Our unique
            service enables job postings to be completed in under two minutes,
            utilizing pre-filled job descriptions and reaching a large database
            of active job seekers. Each job post is managed by dedicated client
            representatives and a jobseeker team that screens all applications.
          </p>
          <div class="is-flex gap-1">
            <a
              id="btn-post-a-job-about"
              class="button is-employer text-14 column is-4 is-flex mt-4"
              @click="gotoJobPost()"
            >
              Post Job</a
            >
          </div>
        </div>
        <div class="column is-6 mb-0 is-flex is-flex-direction-column">
          <iframe
            class="rounded-10 fill-height width-auto min-height-16rem"
            src="https://www.youtube.com/embed/t_b2WD50uYM"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </section>
    <section class="is-flex has-background-light-orange py-10 is-full-width">
      <div
        class="columns container has-margin-auto mb-5 is-full-width"
        :class="
          screen === 'mobile' ? 'pa-4' : 'padding-right-70px padding-left-70px'
        "
      >
        <div class="column is-6 mb-0 is-flex is-flex-direction-column">
          <iframe
            class="rounded-10 fill-height width-auto min-height-16rem"
            src="https://www.youtube.com/embed/t_b2WD50uYM"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="column is-6">
          <div class="is-size-3 has-text-weight-medium pb-3">
            Job Matching Services
          </div>
          <p class="text-14 has-text-justified has-text-centered-mobile">
            Job matching is the process of matching employer requirements and
            worker by reviewing and short listing the job seeker profile as per
            agreed by both organizations. Shortlisted worker will be called for
            face to face interview and final selection of forwarded candidate
            will be decided by the client. Rojgari Services have built up
            extensive knowledge in various sectors and know their local markets
            inside out. Most importantly they are familiar with all the various
            large, mid-sized and small businesses We have a proud track record
            of providing fast, responsive and effective recruitment solutions
            and successfully placed more than 8000+ candidates. This covers a
            variety of recruitment services including permanent, intern or
            contractor, search and contingency solutions from graduate entrance
            level to senior management.
          </p>
          <div class="is-flex gap-1">
            <a
              id="btn-contact-about"
              class="button brown-outline text-14 text-brown has-text-weight-semibold column is-4 is-flex mt-4"
              @click="$router.push(localePath('contact'))"
              v-text="$t('Contact Us')"
            ></a>
          </div>
        </div>
      </div>
    </section>
    <section class="py-10">
      <div
        class="container columns gap-1 has-margin-auto is-multiline"
        :class="
          screen === 'mobile' ? 'pa-4' : 'padding-right-70px padding-left-70px'
        "
      >
        <div
          class="column is-12 is-size-3 has-text-weight-medium pb-3 has-text-centered"
        >
          {{ $t('Team Behind Rojgari') }}
        </div>
        <div class="d-grid gap-2 container pa-3 team-rojgari">
          <div class="d-grid gap-2">
            <div class="d-grid gap-2 team-rojgari-img">
              <img src="/images/01.jpg" />
              <img src="/images/02.jpg" class="is-full-width" />
            </div>
            <img src="/images/03.jpg" class="is-full-width" />
          </div>
          <img src="/images/04.jpg" class="is-full-width" />
          <div class="d-grid gap-2">
            <img src="/images/05.jpg" class="is-full-width" />
            <img src="/images/06.jpg" class="is-full-width" />
          </div>
        </div>
        <div class="container py-0 px-4 column is-12">
          <hr class="hr-line ma-0" />
        </div>
        <div class="container columns has-margin-auto">
          <div class="column is-6">
            <div
              class="has-background-light-yellow box pb-0 gap-1 is-flex is-flex-direction-column rounded-10"
            >
              <div class="is-size-5 has-text-weight-medium">
                {{ $t('Are you a jobseeker?') }}
              </div>
              <a
                id="btn-sign-up-jobseeker"
                class="button is-jobseeker text-14 column is-5 is-flex is-12-mobile"
                @click="$router.push('/signup/jobseeker')"
                v-text="$t('Join Now')"
              ></a>
              <img
                class="max-height-9rem object-fit-contain"
                src="/images/account/need-job.png"
                alt="jobseeker-picture"
              />
            </div>
          </div>
          <div class="column is-6">
            <div
              class="has-background-light-brown box pb-0 gap-1 is-flex is-flex-direction-column rounded-10"
            >
              <div class="is-size-5 has-text-weight-medium">
                {{ $t('Are you a employer?') }}
              </div>
              <a
                id="btn-sign-up-employer"
                class="button is-employer text-14 column is-5 is-flex is-12-mobile"
                @click="$router.push('/signup/employer')"
                v-text="$t('Join Now')"
              ></a>
              <img
                src="/images/account/post-job.png"
                alt="jobseeker-picture"
                class="max-height-9rem object-fit-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="is-flex overflow-hidden">
      <div
        class="container"
        :class="
          screen === 'mobile' ? 'pa-4' : 'padding-right-70px padding-left-70px'
        "
      >
        <div class="is-size-3 has-text-weight-medium pb-3 has-text-centered">
          {{ $t('Rojgari App') }}
        </div>
        <div class="container columns">
          <div class="column is-6 is-flex is-flex-direction-column gap-1 pa-4">
            <p class="margin-top-auto">
              Employment to the unemployed, Employee to the Employer, Rojgari
              Pasal is with you, employment is on your hand !!
            </p>
            <div>
              <span class="has-text-weight-semibold">Download</span
              ><a
                id="btn-download-app-google"
                class="text-orange has-text-weight-semibold pointer"
                href="https://play.google.com/store/apps/details?id=com.rojgaripasal.rojgariapp"
                target="_blank"
              >
                Rojgari App
              </a>
              <span class="has-text-weight-semibold"> Today</span>
            </div>
            <div
              class="is-flex is-flex-direction-row margin-bottom-auto gap-1 is-flex-wrap download"
            >
              <a
                id="btn-download-app-google"
                class="text-orange has-text-weight-semibold pointer"
                href="https://play.google.com/store/apps/details?id=com.rojgaripasal.rojgariapp"
                target="_blank"
              >
                <img src="/images/account/android_download.png" />
              </a>
              <a
                id="btn-download-app-google"
                class="text-orange has-text-weight-semibold pointer"
                href="https://apps.apple.com/us/app/rojgari/id1493964641?ign-mpt=uo%3D2"
                target="_blank"
              >
                <img src="/images/account/apple_download.png" />
              </a>
            </div>
          </div>
          <div class="column is-6 pa-0">
            <img
              src="/images/account/new-app-showcase.png"
              class="is-pulled-right"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  methods: {
    goToSignup() {
      this.showNavbarItems = false
      this.$router.push(
        this.localePath({
          name: 'signup'
        })
      )
    },
    gotoJobPost() {
      if (this.$auth.loggedIn && this.$auth.user.employer_profile) {
        if (this.$auth.user.has_filled_initial_form) {
          if (
            this.$auth.user.related_organizations.length &&
            this.$auth.user.is_purchase_available
          ) {
            this.$nuxt.$emit('openinitialform')
          } else if (!this.$auth.user.is_purchase_available) {
            this.$router.push(
              this.localePath({
                name: 'pricing'
              })
            )
          } else {
            this.setDialog({ display: true, type: 'details' })
            this.notifyError(this.$t('Initial profile form not filled'))
          }
        } else {
          this.setDialog({ display: true, type: 'details' })
          this.notifyError(this.$t('Initial profile form not filled'))
        }
      } else {
        this.setDialog({
          display: true,
          type: 'employer-sign-in',
          extraInfo: 'employer-sign-in'
        })
        this.notifyError(
          this.$t('You need to login as an employer to post a job.')
        )
      }
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap');
section {
  font-family: 'Poppins', sans-serif;
}
.left--110px {
  left: -110px;
}
.service-image {
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
}
.service-image img {
  background: #ffffff;
  width: 100%;
  height: 4rem;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  object-fit: contain;
  padding: 0.5rem 1rem;
  transition: 0.3s;
}

.team {
  position: absolute;
  right: 0px;
  top: 2rem;
  object-fit: contain;
  max-height: 60%;
}
.swastic::before {
  content: '';
  background-image: url('/images/swastic_design.png');
  background-size: contain;
  height: 25rem;
  width: 25rem;
  position: absolute;
  top: -196px;
  left: -196px;
  z-index: -1;
  opacity: 0.4;
}
.vertical-line {
  margin: auto;
  height: 136px;
  width: 0px;
  border-color: orange;
}
.team-rojgari {
  grid-template-columns: repeat(3, 1fr);
}
.team-rojgari-img {
  grid-template-columns: 1fr 2fr;
}
.team-rojgari img {
  border-radius: 24px;
  height: 34rem;
  object-fit: cover;
  transition: 0.5s;
}
.team-rojgari div img {
  border-radius: 24px;
  height: 16rem;
  object-fit: cover;
  transition: 0.5s;
}
.team-rojgari img:hover {
  transform: scale(1.02);
}
@media screen and (max-width: 768px) {
  section * {
    text-align: center !important;
  }
  .swastic {
    margin-bottom: 2rem !important;
  }

  .height-108vh {
    padding: 12rem 1rem 1rem;
    height: auto;
    max-height: unset;
  }
  .height-108vh .is-1,
  .swastic::before {
    display: none;
  }
  .team {
    top: -10rem;
    width: 100%;
  }
  .team-rojgari,
  .team-rojgari-img {
    grid-template-columns: 1fr;
  }
  .team-rojgari img,
  .team-rojgari div img {
    height: 16rem;
    width: 100%;
  }
  .download {
    place-content: center;
  }
}
@media screen and (min-width: 1400px) {
  .team {
    max-height: 68%;
  }
}
</style>
